import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { useDataFetch } from '@common/hooks/dataFetch';
import { SportTypesUrls } from '@racings/constants/enums/sportTypes';
import { fetchRequest } from '@common/helpers/util/requestMiddleware';
import { GetArrayEvent, GetArrayMarket } from '@common/helpers/util/swarmTreeDestructuring';
import { getRacingEventData } from '@racings/helpers/getRacingEventData';
import { eventsListSorter } from '@racings/helpers/eventsListSorter';
import moment from 'moment';
import { useTranslation } from '@common/hooks/translation';
import { RacingEvent } from './racingEvent';

export const RacingCard = ({ game }) => {
  const { sportType } = useParams();
  const navigate = useNavigate();
  const t = useTranslation();
  const [racingData] = useDataFetch(
    () => sportType === SportTypesUrls.HORSE
      && fetchRequest('https://horseracing.betcoapps.com', `rc/${game.id}.json`, 'GET'),
    [],
  );

  const markets = GetArrayMarket(game.market);
  const winnerMarket = markets.find((market) => market.market_type === 'Winner');

  if (!winnerMarket) return null;

  const goToRacing = () => navigate(
    `/betting/racings/${sportType}/upComing/${game.region_alias}/${game.competitionId}/${game.id}?dateFilter=${game.start_ts}`,
  );

  const events = GetArrayEvent(winnerMarket.event).sort(eventsListSorter).slice(0, 3);

  const extraInfo = winnerMarket?.extra_info;

  return (
    <div className="coming-racing-card" onClick={goToRacing}>
      <div className="region-header-wrapper">
        <div className="region-header">
          <div className="region-name">
            <div className="time">{moment.unix(game.start_ts).format('HH:mm')}</div>
            <span className={`flag icon-${game.region_alias.toLowerCase().replaceAll(' ', '')} flag`} />
            {game.competitionName} {game.id}
          </div>
          <div className="market-name">
            {extraInfo && (
              <div className="game-number-wrapper info-item">
                {t('Each Way')}
                :
                {' '}
                <span>
                  1/
                  {winnerMarket.extra_info.EachWayK}
                  {' '}
                  {t('Odds')}
                  {' '}
                  {extraInfo.EachWayPlace}
                  {' '}
                  {t('Places')}
                </span>
              </div>
            )}
          </div>
        </div>
        <i className="global-icon icon-slim-arrow-right" />
      </div>

      <div className="events-list">
        {events.filter((item) => !item.nonrunner).map((event, index) => (
          <RacingEvent
            game={game}
            index={index}
            event={event}
            key={event.id}
            market={winnerMarket}
            racingData={getRacingEventData(racingData, event.type)}
          />
        ))}
      </div>
    </div>
  );
};
